export const DataReportMenu = {
  routes: [
    {
      name: 'data_integrations',
      displayName: 'menu.data_integrations',
      subject_class: 'DataIntegrations',
    },
    {
      name: 'notifications',
      displayName: 'menu.notifications',
      subject_class: 'Notifications',
    },
  ],
}
